import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { isRequired } from 'components/Questionnaires/validators';

import LocalisedMessage from 'components/Common/LocalisedMessage';
import { HintButton } from 'components/Common/Buttons';

const Question = ({ blockId, question, messageValues, onChange }) => {
  const intl = useIntl();
  const [isEdited, setIsEdited] = useState(question.answer !== undefined);
  const [showInstructions, setShowInstructions] = useState(false);

  const viewInstructions = () => {
    setShowInstructions(!showInstructions);
  };

  const onQuestionChange = (q, value) => {
    setIsEdited(true);
    onChange(q, value);
  };

  const questionRequired = useMemo(() => isRequired(question), [question.validation?.conditions]);

  useEffect(() => {
    if (question.isForceEdited === true) {
      setIsEdited(true);
    }
  }, [question.isForceEdited]);

  return (<div id={ `${ blockId }-${ question.id }-question` } className={ `question ${ question.className ?? 'col-12' }` }>
    <span className="d-block" id={ `${ blockId }-${ question.id }-lbl` }>
      { question.label && <legend className="question-title d-inline-block mt-2 mb-1">
        <LocalisedMessage id={ question.label } values={ messageValues } />{ questionRequired ? ' *' : '' }
        { question.info?.instructions && <HintButton active={ showInstructions } hintType="hint" hintLabel={ intl.formatMessage({ id: question.label }) } onClick={ () => viewInstructions() } /> }
      </legend> }
    </span>
    { showInstructions && <div className="info mt-1">{ typeof question.info.instructions === 'string' ? <LocalisedMessage id={ question.info.instructions } values={ messageValues } /> : question.info.instructions }</div> }
    <div className="fields-container">
      <div className="inputs-container">
        { React.createElement(question.component, { intl, blockId, question, ...question.componentProps, onChange: onQuestionChange }) }
        { question.info?.footnote && <span className="sub-text"><LocalisedMessage id={ question.info.footnote } /></span> }
        { question.info?.component && React.createElement(question.info.component, { messageValues, ...question.info.componentProps }) }
        { question.isValid === false && isEdited && <div id={ `${ blockId }-${ question.id }-error` } className="error-container" aria-live="polite" role="alert">
          <ul>{ question.errorMessages.map(e => <li key={ e }><FontAwesomeIcon icon="times" className="i-cross" /><span>{ intl.formatMessage({ id: e }) }</span></li>) }</ul>
        </div> }
      </div>
    </div>
  </div>);
};

Question.propTypes = {
  blockId: PropTypes.string.isRequired,
  question: PropTypes.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  messageValues: PropTypes.shape()
};

Question.defaultProps = {
  messageValues: {}
};

export default Question;
